import React from 'react';
import { Link as InternalLink } from 'gatsby';
import { graphql, StaticQuery } from 'gatsby';
import * as styles from './Footer.module.styl';

function Link(props) {
  if (props.href) {
    return <a {...props}>{props.children}</a>;
  }
  return <InternalLink {...props}>{props.children}</InternalLink>;
}

function AutoLink({ url, text }) {
  if (url && url.startsWith('/')) {
    return <Link to={url}>{text}</Link>;
  }
  return <a href={url}>{text}</a>;
}

function Footer({ data, className }) {
  return (
    <div className={`bg-stone text-black ${className || ''}`}>
      <div className={styles.wrapper}>
        {data.columns.map((column) => (
          <div key={column.title} className={styles.column}>
            <b>{column.title}</b>
            {column.links.map((link, i) => (
              <AutoLink key={i} {...link} />
            ))}
          </div>
        ))}
      </div>
      <div className={styles.legal}>
        <Link to="/terms/">Terms & Conditions of Use</Link> ·{' '}
        <Link to="/website-terms/">Website Terms of Use</Link> ·{' '}
        <Link to="/privacy/">Privacy Policy</Link> · © Paperform{' '}
        {new Date().getFullYear()}
      </div>
    </div>
  );
}

export default function FooterData(props) {
  return (
    <StaticQuery
      query={graphql`
        query FooterQuery {
          paperformHelpFooter(slug: { eq: "footer" }) {
            columns {
              title
              links {
                text
                url
              }
            }
          }
        }
      `}
      render={(data) => <Footer data={data.paperformHelpFooter} {...props} />}
    />
  );
}
